import { createContext } from "react";

const OrderIdContext = createContext("");

const StageContext = createContext("");

export { OrderIdContext, StageContext };
